function setSelectedVariant(element) {
  // Get necessary attributes
  let variantId = element.getAttribute("data-variant-id");
  let productId = element.getAttribute("data-product-id");
  let variantAvailable = element.getAttribute("available") === "true";

  // Update hidden input value
  let hiddenInput = document.querySelector("#sv_" + productId);
  if (hiddenInput) {
    hiddenInput.setAttribute("value", variantId);
  }

  // Update submit button state
  let submitButton = document.querySelector("#ProductSubmitButton_" + productId);
  let buttonText = document.querySelector("#ProductButtonText_" + productId);

  if (submitButton && buttonText) {
    if (variantAvailable) {
      submitButton.removeAttribute("disabled");
      buttonText.textContent = "Add to Cart";
    } else {
      submitButton.setAttribute("disabled", "true");
      buttonText.textContent = "Sold out";
    }
  }

  // Update selected class within the same product container
  let container = element.closest(".grid__item");
  if (container) {
    let previouslySelectedElements = container.querySelectorAll(".variant-link.selected");
    previouslySelectedElements.forEach((el) => el.classList.remove("selected"));
  }

  element.classList.add("selected");
}

// Select the first variant in each product grid item on page load
document.addEventListener("DOMContentLoaded", function () {
  let productContainers = document.querySelectorAll(".grid__item");

  productContainers.forEach((container) => {
    // Find the first selected variant inside the container
    let firstSelectedVariant = container.querySelector(".variant-link.selected");
    
    // If no variant is already selected, fallback to the first available variant
    if (!firstSelectedVariant) {
      firstSelectedVariant = container.querySelector(".variant-link");
    }

    if (firstSelectedVariant) {
      setSelectedVariant(firstSelectedVariant);
    }
  });
});
